<template>
   <div>
        <div class="table-wrapper on-991" v-if="$i18n.locale=='en'">
                <div>
                    <table>
                        <thead>
                            <tr class="dark-gray">
                                <td><span class="invisible">asd</span></td>
                                <td class="ligest-gray text-right skyBlue bolder">2020</td>
                                <td class="text-right font-weight-bold text-white">2019<br/>Restated</td>
                            </tr>
                            <tr class="med-gray">
                                <td><span class="invisible">asd</span></td>
                                <td colspan="2" class="text-center text-white font-weight-bold">KD ’000</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Total borrowings including lease liabilities (refer note 15 and 16)</td>
                                <td class="ligest-gray text-right">1,378,504 </td>
                                <td class="text-right">1,585,797</td>
                            </tr>
                            <tr>
                                <td>Less: Cash and bank balances (refer note 4)</td>
                                <td class="ligest-gray text-right"> (393,060)</td>
                                <td class="text-right">(296,985)</td>
                            </tr>
                            <tr>
                                <td>Net debt</td>
                                <td class="ligest-gray text-right">985,444</td>
                                <td class="text-right">1,288,812</td>
                            </tr>
                            <tr class="light-gray">
                                <td class="text-white font-weight-bold">Total equity</td>
                                <td class="text-white font-weight-bold text-right">1,934,544</td>
                                <td class="text-white font-weight-bold text-right">1,678,599</td>
                            </tr>
                            <tr class="med-gray">
                                <td class="text-white font-weight-bold">Total capital</td>
                                <td class="text-white font-weight-bold text-right">2,919,988</td>
                                <td class="text-white font-weight-bold text-right">2,967,411</td>
                            </tr>
                            <tr class="dark-gray">
                                <td class="text-white font-weight-bold">Gearing ratio</td>
                                <td class="text-white font-weight-bold text-right">34%</td>
                                <td class="text-white font-weight-bold text-right">43%</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
        </div>

        <!-- Arabic -->

        <div class="table-wrapper on-991" v-if="$i18n.locale=='ar'">
               <div>
                    <table>
                        <thead>
                            <tr class="dark-gray">
                                <td><span class="invisible">asd</span></td>
                                <td class="ligest-gray text-right skyBlue bolder">2020</td>
                                <td class="text-right font-weight-bold text-white">2019</td>
                            </tr>
                            <tr class="med-gray">
                                <td><span class="invisible">asd</span></td>
                                <td colspan="2" class="text-center text-white font-weight-bold">ألف دينار كويتي</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>إجمالي القروض بما في ذلك التزامات عقد الإيجار (انظر الإيضاحين رقمي 15 و 16)</td>
                                <td class="ligest-gray text-right">1,378,504 </td>
                                <td class="text-right">1,585,797</td>
                            </tr>
                            <tr>
                                <td>ناقصاً: النقد والأرصدة البنكية (انظر إيضاح رقم 4)</td>
                                <td class="ligest-gray text-right">(393,060)</td>
                                <td class="text-right">(296,985)</td>
                            </tr>
                            <tr>
                                <td>صافي الديون</td>
                                <td class="ligest-gray text-right">985,444</td>
                                <td class="text-right">1,288,812</td>
                            </tr>
                            <tr class="light-gray">
                                <td class="text-white font-weight-bold">إجمالي حقوق الملكية</td>
                                <td class="text-white font-weight-bold text-right">1,934,544</td>
                                <td class="text-white font-weight-bold text-right">1,678,599</td>
                            </tr>
                            <tr class="med-gray">
                                <td class="text-white font-weight-bold">إجمالي رأس المال</td>
                                <td class="text-white font-weight-bold text-right">2,919,988</td>
                                <td class="text-white font-weight-bold text-right">2,967,411</td>
                            </tr>
                            <tr class="dark-gray">
                                <td class="text-white font-weight-bold">معدل المديونية</td>
                                <td class="text-white font-weight-bold text-right">34%</td>
                                <td class="text-white font-weight-bold text-right">43%</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
        </div>
   </div>
</template>

<script>
export default {

}
</script>

<style>

</style>